const CAPTCHA_SCRIPT_SRC = 'https://turing.captcha.qcloud.com/TCaptcha.js'

let tencentCaptchaPromise = null

export function loadTencentCaptchaScript() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('验证码加载失败，请稍后重试'))
  }

  if (window.TencentCaptcha) {
    return Promise.resolve(window.TencentCaptcha)
  }

  if (tencentCaptchaPromise) {
    return tencentCaptchaPromise
  }

  tencentCaptchaPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${CAPTCHA_SCRIPT_SRC}"]`)
    const script = existingScript || document.createElement('script')

    const cleanup = () => {
      script.removeEventListener('load', handleLoad)
      script.removeEventListener('error', handleError)
    }

    const handleLoad = () => {
      cleanup()
      if (window.TencentCaptcha) {
        resolve(window.TencentCaptcha)
        return
      }

      tencentCaptchaPromise = null
      reject(new Error('验证码加载失败，请稍后重试'))
    }

    const handleError = () => {
      cleanup()
      tencentCaptchaPromise = null
      reject(new Error('验证码加载失败，请稍后重试'))
    }

    script.addEventListener('load', handleLoad)
    script.addEventListener('error', handleError)

    if (!existingScript) {
      script.src = CAPTCHA_SCRIPT_SRC
      script.async = true
      script.defer = true
      script.setAttribute('data-tencent-captcha', 'true')
      document.head.appendChild(script)
      return
    }

    if (window.TencentCaptcha) {
      cleanup()
      resolve(window.TencentCaptcha)
    }
  })

  return tencentCaptchaPromise
}
